import React from "react";
import { Link } from "react-router-dom";
import { SUBMIT_ISSUE} from "./link";

const getProfileLink = (dataArray, prefix) =>
  dataArray.map((item) => ({
    key: item.key,
    label: item.isExternal ? (
      <Link to={item.to} target="_blank" rel="noreferrer" className="headerLink">
        <span>{item.title}</span>
      </Link>
    ) : (
      <Link to={`${prefix}${item.to}`} className="headerLink">
        <span>{item.title}</span>
      </Link>
    ),
  }));

export const profileLinksArr = [
  {
    key: "1",
    title: "My Profile",
    to: "/profile",
    isExternal: false,
  },
  {
    key: "2",
    title: "My Payments",
    to: "/profile#balance-history",
    isExternal: false,
  },
  {
    key: "3",
    title: "Add Funds",
    to: "/profile#billing",
    isExternal: false,
  },
  {
    key: "4",
    title: "My Migrations List",
    to: "/migrations/list",
    isExternal: false,
  },
  {
    key: "5",
    title: "Generate Invoice",
    to: "/profile#generate-invoice",
    isExternal: false,
  },
  // {
  //   key: "6",
  //   title: "Notifications & Alerts",
  //   to: "/",
  // },
  {
    key: "7",
    title: "Help & Support",
    to: "chat",
    isExternal: false,
  },
  {
    key: "8",
    title: "Submit an Issue",
    to: SUBMIT_ISSUE,
    isExternal: true,
  },
];

const adminLink = (prefix) => [
  {
    title: "Profile",
    items: getProfileLink(profileLinksArr, prefix),
  },
];

export const getProfileLinks = (prefix) => adminLink(prefix);
